import { render, staticRenderFns } from "./sliderCategorias.vue?vue&type=template&id=867dd9ac&scoped=true&"
import script from "./sliderCategorias.vue?vue&type=script&lang=js&"
export * from "./sliderCategorias.vue?vue&type=script&lang=js&"
import style0 from "./sliderCategorias.vue?vue&type=style&index=0&id=867dd9ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "867dd9ac",
  null
  
)

export default component.exports